module.exports = [{
      plugin: require('../node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":1200,"wrapperStyle":"margin-left: auto; margin-right: auto; width: 80%; margin-top: 40px; margin-bottom: 40px;","quality":100,"withWebp":true,"withAvif":true,"linkImagesToOriginal":false,"showCaptions":true,"markdownCaptions":true,"backgroundColor":"transparent","disableBgImage":false,"loading":"lazy","decoding":"async","disableBgImageOnAlpha":false},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
